import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { Alert } from '../components';

/** Body of the status pages (404/403/500/maintenance); rendered inside StatusLayout or AppLayout. */
export function StatusMessage({
  code,
  children,
  actions,
}: {
  code: string;
  children: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="flex max-w-prose flex-col gap-3 text-base">
      {children}
      {actions && <div className="flex flex-wrap gap-3">{actions}</div>}
      <p className="text-xs text-ink-muted">{code}</p>
    </div>
  );
}

export function ForbiddenContent() {
  return (
    <div className="flex flex-col gap-3">
      <Alert tone="warning" title="Access denied">
        Your access level is too low to use this page. Ask an administrator if you need it.
      </Alert>
      <p className="text-sm">
        <Link to="/">Go to My view</Link>
      </p>
    </div>
  );
}
